module.exports = {"StatusCode":200,"Payload":[{"planId":"some-plan-id","planPrice":12,"forecastKey":"some-forecast-key","lifecycle":"published","tier":"Starter","cloudFront":{"domain":"d23o7uvq04ra4f.cloudfront.net","id":"E2IFPUWYGH4777"}}]}


//////////////////
// WEBPACK FOOTER
// ./src/payloads/aws/lambda/mocks/goLiveSite.json
// module id = TkmF
// module chunks = 0